import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { WashingMachine, Menu, X } from 'lucide-react';
import { Button } from './ui/Button';
export function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navigation = [{
    name: 'Home',
    href: '/'
  }, {
    name: 'About',
    href: '/about'
  }, {
    name: 'Strategy',
    href: '/strategy'
  }, {
    name: 'Team',
    href: '/team'
  }];
  const isActive = (path: string) => location.pathname === path;
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-[#0f2424]/95 backdrop-blur-sm border-b border-gray-800" data-id="element-150">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-151">
        <div className="flex justify-between items-center h-20" data-id="element-152">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2 group" data-id="element-153">
            <WashingMachine className="h-8 w-8 text-[#4fd1c5] group-hover:rotate-180 transition-transform duration-500" data-id="element-154" />
            <span className="text-xl font-bold text-white tracking-tight" data-id="element-155">
              LAUNDRY <span className="font-light" data-id="element-156">INVESTORS</span>
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-157">
            {navigation.map(item => <Link key={item.name} to={item.href} className={`text-sm font-medium transition-colors relative group ${isActive(item.href) ? 'text-[#4fd1c5]' : 'text-gray-300 hover:text-white'}`} data-id="element-158">
                {item.name}
                <span className={`absolute -bottom-1 left-0 w-full h-0.5 bg-[#4fd1c5] transform origin-left transition-transform ${isActive(item.href) ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100'}`} data-id="element-159" />
              </Link>)}
            <Link to="/contact" data-id="element-160">
              <Button size="sm" data-id="element-161">Contact Us</Button>
            </Link>
          </div>

          {/* Mobile menu button */}
          <button onClick={() => setIsOpen(!isOpen)} className="md:hidden p-2 rounded-lg text-gray-300 hover:text-white hover:bg-[#1a3a3a] transition-colors" data-id="element-162">
            {isOpen ? <X className="h-6 w-6" data-id="element-163" /> : <Menu className="h-6 w-6" data-id="element-164" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isOpen && <div className="md:hidden border-t border-gray-800 bg-[#0f2424]" data-id="element-165">
          <div className="px-4 py-6 space-y-4" data-id="element-166">
            {navigation.map(item => <Link key={item.name} to={item.href} onClick={() => setIsOpen(false)} className={`block px-4 py-2 rounded-lg text-base font-medium transition-colors ${isActive(item.href) ? 'text-[#4fd1c5] bg-[#1a3a3a]' : 'text-gray-300 hover:text-white hover:bg-[#1a3a3a]'}`} data-id="element-167">
                {item.name}
              </Link>)}
            <Link to="/contact" onClick={() => setIsOpen(false)} data-id="element-168">
              <Button size="sm" className="w-full" data-id="element-169">
                Contact Us
              </Button>
            </Link>
          </div>
        </div>}
    </nav>;
}